<template>
  <div>
    <div class="closepass-button">
      <Button
        @click="pushBack"
        icon="pi pi-times"
        class="p-button-rounded p-button-text p-button-plain"
      />
    </div>
    <div v-if="this.isLoading" class="orderprice__skeleton-wrapper">
      <Skeleton
        class="orderprice__skeleton-title"
        width="260px"
        height="24px"
      />
      <Skeleton class="orderprice__skeleton-type" width="240px" height="22px" />
      <div class="orderprice__skeleton-headers">
        <Skeleton
          class="orderprice__skeleton-headers__name"
          width="170px"
          height="20px"
        />
        <Skeleton
          class="orderprice__skeleton-headers__sum"
          width="50px"
          height="20px"
        />
      </div>
      <div class="orderprice__skeleton-items">
        <Skeleton
          class="orderprice__skeleton-items__name"
          width="100px"
          height="20px"
        />
        <Skeleton
          class="orderprice__skeleton-items__sum"
          width="80px"
          height="20px"
        />
      </div>
      <div class="orderprice__skeleton-items">
        <Skeleton
          class="orderprice__skeleton-items__name"
          width="100px"
          height="20px"
        />
        <Skeleton
          class="orderprice__skeleton-items__sum"
          width="80px"
          height="20px"
        />
      </div>
      <div class="orderprice__skeleton-sum">
        <Skeleton
          class="orderprice__skeleton-sum__name"
          width="50px"
          height="20px"
        />
        <Skeleton
          class="orderprice__skeleton-sum__sum"
          width="100px"
          height="20px"
        />
      </div>
    </div>
    <div v-else class="choosen-order__info-price__descr-wrap">
      <p class="choosen-order__info-price__descr-title">
        Расчет стоимости заказа
      </p>
      <p class="choosen-order__info-price__descr-type">
        {{
          "Тип оплаты:  " + getPaymentType(this.calculations.order.PaymentForm)
        }}
      </p>
      <div class="choosen-order__info-price__descr-titles">
        <p class="choosen-order__info-price__descr-titles__name">
          Наименование услуги
        </p>
        <p class="choosen-order__info-price__descr-titles__sum">Сумма</p>
      </div>
      <div
        class="choosen-order__info-price__descr-item"
        v-for="(calc, index) in this.calculations.order.PriceCalculation
          .Passengers"
        :key="index"
      >
        <div
          v-for="(price, indexTwo) in getPriceType(calc.Items)"
          :key="indexTwo"
          class="choosen-order__info-price__descr-item__item"
        >
          <p>{{ price.Description }}</p>
          <p>{{ price.Amount.toFixed(2) + " ₽" }}</p>
        </div>
      </div>
      <div class="choosen-order__info-price__descr-sum">
        <p>Итого</p>
        <p>
          {{
            getTotalPrice(
              this.calculations.order.PriceCalculation.Passengers
            ).toFixed(2) + " ₽"
          }}
        </p>
      </div>
        <Button
          v-if="this.calculations.order.Check.length > 0"
          label="Фискальный чек"
          class="choosen-order__info-price__descr-check__link"
          @click="saveCheck(this.calculations.order.Check[0])"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { ref } from "vue";
import useClipboard from "vue-clipboard3";
import Button from "primevue/button";
import axios from "axios";
import Skeleton from "primevue/skeleton";
import { useRouter, useRoute } from "vue-router";
import store from "../store";

const axioCred = axios.create({
  withCredentials: true,
});

export default defineComponent({
  name: "OrderPrice",
  components: {
    Button,
    Skeleton,
  },
  props: ["order"],
  setup(props) {
    const isLoading = ref(false);
    const error = ref(null);
    const router = useRouter();
    const route = useRoute();
    const calculations = ref(null);
    const getOrderPrice = async () => {
      isLoading.value = true;
      try {
        const json = await axioCred.get(
          `https://www.biletdv.ru/customer/IBEServices/GetOrderPriceInfo?guid=${props.order}`
        );
        let fetchedPass = await json.data;
        calculations.value = fetchedPass;
        console.log(calculations.value);
        
        isLoading.value = false;
      } catch (err) {
        if (err.response.status == 401) {
          store.dispatch("auth/logout");
          router.push("/login");
        }
      }
    };
    return {
      isLoading,
      error,
      calculations,
      getOrderPrice,
    };
  },
  methods: {
    getPaymentType(num: number) {
      switch (num) {
        case 1:
          return "Наличные";
        case 4:
          return "Банковская карта";
        case 9:
          return "Банковская карта";
        case 10:
          return "Банковская карта";
        case 6:
          return "Рапида";
        case 7:
          return "Аванс";
        case 8:
          return "Platron";
        case 11:
          return "КР";
        case 12:
          return "ВТ";
        case 13:
          return "ВЗ";
        case 14:
          return "РТА";
        case 15:
          return "ЮKassa";
        case 16:
          return "ЮKassa (Оплата по частям)";
        default:
          return "Не оплачен";
      }
    },
    getTotalPrice(Passengers: any) {
      let totalPrice = 0;
      for (const elem of Passengers) {
        let items = elem.Items;
        for (const el of items) {
          totalPrice += el.Amount;
        }
      }
      return totalPrice;
    },
    getPriceType(items: any) {
      let newArr: any = [{ Description: "Авиабилет", Amount: 0 }];
      for (const elem of items) {
        if (
          elem.ItemType == 1 ||
          elem.ItemType == 202 ||
          elem.ItemType == 335
        ) {
          newArr[0].Amount += elem.Amount;
        } else {
          newArr.push(elem);
        }
      }
      return newArr;
    },
    saveCheck(check: any) {
      if (new Date(check.Created) < new Date("2021-07-02")) {
        return window.open(`https://check.ofd.ru/rec/2722046551/0001024243050065/9281000100190066/${check.KkmReceiptNumber}/${check.FiscalSign}`, '_blank');
      } else if (new Date(check.Created) < new Date("2021-08-05")) {
        return window.open(`https://check.ofd.ru/rec/2722046551/0002583594045857/9281000100190065/${check.KkmReceiptNumber}/${check.FiscalSign}`, '_blank');
      } else if (new Date(check.Created) < new Date("2024-08-16")) {
        return window.open(`https://check.ofd.ru/rec/2722046551/0002583594045857/9961440300003121/${check.KkmReceiptNumber}/${check.FiscalSign}`, '_blank');
      } else {
        return window.open(`https://check.ofd.ru/rec/2722046551/0002583594045857/7381440800279896/${check.KkmReceiptNumber}/${check.FiscalSign}`, '_blank');
      }
    },
    pushBack() {
      this.$router.back();
    },
  },
  created() {
    this.getOrderPrice();
  },
});
</script>

<style>
.orderprice__skeleton-headers {
  margin-top: 15px;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.orderprice__skeleton-items {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.orderprice__skeleton-sum {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.choosen-order__info-price__descr-wrap {
  padding: 0 5px;
}

.choosen-order__info-price__descr-title {
  font-weight: 700;
  font-size: 20px;
  color: black;
}

.choosen-order__info-price__descr-titles {
  margin-top: 15px;
  margin-bottom: 10px;
  color: black;
  display: flex;
  justify-content: space-between;
}

.choosen-order__info-price__descr-item {
  margin-top: 5px;
  color: black;
  display: flex;
  flex-direction: column;
}

.choosen-order__info-price__descr-item__item {
  margin-top: 5px;
  display: flex;
  justify-content: space-between;
}

.choosen-order__info-price__descr-sum {
  margin-top: 10px;
  color: black;
  display: flex;
  justify-content: space-between;
  font-weight: bold;
}

.choosen-order__info-price__descr-wrap {
  display: flex;
  flex-direction: column;
}

.choosen-order__info-price__descr-check__link {
  display: block;
  margin-top: 30px !important;
  margin-left: auto !important;
  margin-right: auto !important;
  text-decoration: none;
  background-color: #2196f3;
}

</style>
